import { Injectable } from '@angular/core';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Injectable({
  providedIn: 'root',
})
export class BottomSheetService {
  private currentBottomSheetRef: MatBottomSheetRef<any> | null = null;

  constructor(private bottomSheet: MatBottomSheet) {}

  /**
   * Abre un bottom sheet con el componente especificado
   * @param component El componente a mostrar en el bottom sheet
   * @param data Los datos a pasar al componente
   * @returns Una referencia al bottom sheet abierto
   */
  open<T, D = any, R = any>(component: any, data?: D): MatBottomSheetRef<T, R> {
    // Cerrar el bottom sheet actual si existe
    this.close();

    // Abrir el nuevo bottom sheet
    this.currentBottomSheetRef = this.bottomSheet.open(component, {
      data: data,
      panelClass: 'custom-bottom-sheet',
      backdropClass: 'custom-bottom-sheet-backdrop',
      hasBackdrop: true,
      disableClose: false,
      closeOnNavigation: true,
      restoreFocus: true,
      autoFocus: false, // No auto-focus para evitar problemas con el header
    });

    // Limpiar la referencia cuando se cierre
    this.currentBottomSheetRef.afterDismissed().subscribe(() => {
      this.currentBottomSheetRef = null;
    });

    return this.currentBottomSheetRef;
  }

  /**
   * Cierra el bottom sheet actual
   */
  close(result?: any): void {
    if (this.currentBottomSheetRef) {
      this.currentBottomSheetRef.dismiss(result);
      this.currentBottomSheetRef = null;
    }
  }

  /**
   * Verifica si hay un bottom sheet abierto
   */
  isOpen(): boolean {
    return this.currentBottomSheetRef !== null;
  }
}
